var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{staticClass:"calculator-amortiz-chart",staticStyle:{"height":"26vw"},attrs:{"id":"nu-chart"}})])
}]

export { render, staticRenderFns }